import { Link } from 'react-router-dom';
import { IconUpload, IconAlert } from '../ui/icons';

const actions = [
  {
    to: '/submission/new',
    title: 'New submission',
    body: 'Program, documents, and data tape in one flow.',
    Icon: IconUpload,
    cta: 'Open wizard',
    iconClass: 'bg-eorig-navy-600/10 text-eorig-navy-600',
    ctaClass: 'bg-eorig-gradient text-white hover:opacity-95',
  },
  {
    to: '/exceptions',
    title: 'Resolve exceptions',
    body: 'Cure issues before authority review.',
    Icon: IconAlert,
    cta: 'Go to queue',
    iconClass: 'bg-rose-50 text-rose-600',
    ctaClass:
      'border border-eorig-border bg-white text-eorig-ink hover:bg-eorig-surface',
  },
];

export function OriginatorQuickActions() {
  return (
    <section aria-labelledby="quick-actions-heading">
      <h2
        id="quick-actions-heading"
        className="mb-2 text-sm font-semibold text-eorig-ink"
      >
        Quick actions
      </h2>
      <div className="grid gap-3 sm:grid-cols-2">
        {actions.map(({ to, title, body, Icon, cta, iconClass, ctaClass }) => (
          <div
            key={to}
            className="rounded-2xl border border-eorig-border bg-white p-4 shadow-eorig-card"
          >
            <div className="flex items-start gap-3">
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${iconClass}`}
              >
                <Icon className="h-4 w-4" />
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm font-semibold text-eorig-ink">{title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-eorig-muted">
                  {body}
                </p>
                <Link
                  to={to}
                  className={`mt-3 inline-flex items-center justify-center rounded-full px-3 py-1.5 text-xs font-semibold transition ${ctaClass}`}
                >
                  {cta}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
